import styled from '@emotion/styled'
import Box from '@mui/material/Box'

export const CustomDialog = styled(Box)({
  borderRadius: '1rem',
  background: '#FFF',
})

export const FileUploadSection = styled(Box)({
  border: '2px dashed #C1C1C1',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 5,
  cursor: 'pointer',
  flexDirection: 'column',
  gap: '1rem',
  padding: '1rem',
})
